import { useCallback } from 'react';
import { useLocalSet } from '@/core/storage/local';
import { track } from '@/core/tracking';

/** Favoritos de produtos — no navegador até o back ter o contexto products. */
export function useFavorites(userId: string) {
  const { ids, has, toggle } = useLocalSet(`favoritos:${userId}`);
  // Fica só no navegador, então a atividade é relatada daqui (o nome, a API resolve pelo id).
  const toggleAndTrack = useCallback(
    (id: string) => {
      track({
        action: has(id) ? 'product.unfavorited' : 'product.favorited',
        targetType: 'product',
        targetId: id,
      });
      toggle(id);
    },
    [has, toggle],
  );
  return { ids, isFavorite: has, toggle: toggleAndTrack };
}
